import { Component, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

enum Selectors {
	AnchorLink = '.js-m-anchor-navigation__item > .a-link',
}

@Component('AnchorNavigation')
export class AnchorNavigation extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}

	@EventListener('click', Selectors.AnchorLink)
	private _handleAnchorListClick(ev: MouseEvent) {
		const $eventTarget = $(ev.currentTarget!);
		const anchorElement = $eventTarget.get(0) as HTMLAnchorElement;
		const hash = anchorElement.hash;

		if (hash) {
			const $target = $(hash);

			if ($target.length) {
				ev.preventDefault();
				const $root = $('html, body');

				$root.animate(
					{
						scrollTop: $target.offset()!.top,
					},
					750,
					() => {
						// change focus (so next tab is not misplaced, see also https://css-tricks.com/smooth-scrolling-accessibility/)
						const $focusTarget = $target;

						$focusTarget.focus();
						if ($focusTarget.is(':focus')) {
							// check if target received focus
							return false;
						} else {
							$focusTarget.attr('tabindex', '-1'); // for elements not focusable
							$focusTarget.focus(); // focus again
							return true;
						}
					}
				);
			}
		}
	}
}
